import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
	},
	content: {
		height: `calc(100% - 56px)`,
		width: '100%',
	},
	header: {
		color: THEME.colors.text.main,
		display: 'flex',
		width: '100%',
	},
	infoPopoverAnchor: {
		paddingLeft: 6,
	},
	infoPopoverContent: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		padding: '0 8px',
		width: 260,
	},
});
